import { ChildrenItem } from "../base"
import { Dialog } from "./model"
import { dialog } from "./diffrence_options"

import dialogIcon from "../../assets/images/leftMenu/component/cx_dialog.png"

export let dialog_children = []

for (let i = 0; i < dialog.length; i++) {
  dialog_children.push(new ChildrenItem("弹框样式" + i, dialogIcon, "cxText", new Dialog(dialog[i])))
}
